import { ToastOptions, ToastQueue } from "@react-stately/toast";
import { ReactNode } from "react";

import { CascadiaToast } from "./types";

export const toastQueue = new ToastQueue<CascadiaToast>({
  maxVisibleToasts: 5,
  hasExitAnimation: true,
});

export function showToast(
  message: ReactNode,
  options: ToastOptions & Omit<CascadiaToast, "message"> = {}
) {
  const { timeout = 4000, type = "info" } = options;

  return toastQueue.add(
    { message, type, position: options.position },
    {
      timeout: timeout > 0 ? Math.max(timeout, 4000) : undefined,
      onClose: options.onClose,
      priority: options.priority,
    }
  );
}
